export default "__VITE_ASSET__EJmdOj4y__"